import React, { useContext } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { LeavesContext } from 'context/leaves';
import { Loading } from 'components/common/Loading';
import { GridView } from 'layout/lights/GridView';
import { filterLeavesByDeviceType, groupByLeafType } from 'modules/leaves';
const LightsComponent = () => {
  const {
    leafStore,
    loading: leavesLoading
  } = useContext(LeavesContext);
  const leaves = leafStore.read();
  if (leavesLoading) {
    // if data is being fetched show loading state
    return <Loading />;
  }
  if (leaves) {
    // filterout the object to only retrieve the subtype light ;
    const lightLeaves = filterLeavesByDeviceType(leaves || {}, ['light']);
    const {
      group: groups = {},
      device: devices = {}
    } = groupByLeafType(lightLeaves);
    const sortedGroups = Object.values(groups).sort((a, b) => a.name.localeCompare(b.name));
    const sortedDevices = Object.values(devices).sort((a, b) => a.name.localeCompare(b.name));
    // create a gridview for light ;
    return <GridView sortedDevices={sortedDevices} sortedGroups={sortedGroups} />;
  }
};
export const Route = createFileRoute('/lights')({
  component: LightsComponent,
  beforeLoad: async ({
    context
  }) => {
    if (process.env.NODE_ENV === 'production' && !context.appFeatures.lights) {
      return redirect({
        to: '/'
      });
    }
  }
});
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}